import { format } from 'date-fns';
import { safelyConsoleError } from './safely-console-error';

/**
 * Creates a description for a specific date.
 * @param date - (required) The date to describe.
 * @param suffix - (optional) What to append the description with - a good use case is (Today)/(Tomorrow)
 * @returns A string describing the date.
 * @example
 * const date = new Date('2023-10-01'); // assume this is today
 * const description = createDateDescription(date, '(Today)');
 * // "Sunday, 1st October (Today)"
 */
export const getDateDescription = (date: Date, suffix?: string): string => {
	let label = '';
	if (!date) return label;
	try {
		const dayOfWeek = format(date, 'EEEE');
		const ordinalDay = format(date, 'do');
		const month = format(date, 'MMMM');

		label = `${dayOfWeek}, ${ordinalDay} ${month}`;
	} catch (error) {
		safelyConsoleError('Error formatting date:', error);
		return '';
	}

	if (suffix?.length) label = `${label} ${suffix}`;

	return label;
};
